import { action } from 'typesafe-actions'

export const USER_LOGOUT = 'USER_LOGOUT'

export const onUserLogout = () => action(USER_LOGOUT)
